export const notificationOption = [
  { label: "Seleccionar todos ", value: "all" },
  { label: "Cambio de precio", value: "price" },
  { label: "Cambio de comisión", value: "comission" },
  { label: "Feedback Brokers", value: "brokers" },
  { label: "Ruta de presupuesto", value: "budget" },
  { label: "Ticket de remodelaciones", value: "remo" },
  { label: "Notificaciones leídas", value: "viewed" },
];
